import { apiHelper } from "@/utils";
import { API } from "@/constants";

export const orientationModuleHeaderService = {
  getAll,
  store,
  show,
  update,
  updateStatus,
};

const MODULE = {
  ORIENTATION_MODULE_HEADER: "orientation-module-headers",
};

const API_URL = API.BASE_URL_API + "/v1";

export function getAll(filter) {
  const request = {
    params: {
      usage_type: filter?.usageType,
      page: filter?.pageNumber,
      size: filter?.pageSize,
      is_active: filter?.isActive,
    },
  };

  let array = filter?.searchArray;
  array?.forEach((word, index) => {
    if (word != null || word != "") {
      var searchParam = `search_words[${index}]`;
      request.params[searchParam] = word;
    }
  });

  return apiHelper(API_URL).get(
    `/${MODULE.ORIENTATION_MODULE_HEADER}`,
    request,
  );
}

export function store(data) {
  const request = {
    name: data.name,
    usage_type: data.usageType,
    duration_days: data.durationDays,
    cert_uuid: data.certUuid ?? null,
    is_active: data.isActive,
  };

  return apiHelper(API_URL).post(
    `/${MODULE.ORIENTATION_MODULE_HEADER}`,
    request,
  );
}

export function show(uuid) {
  return apiHelper(API_URL).get(`/${MODULE.ORIENTATION_MODULE_HEADER}/${uuid}`);
}

export function update(data) {
  const request = {
    name: data.name,
    usage_type: data.usageType,
    duration_days: data.durationDays,
    cert_uuid: data.certUuid ?? null,
    is_active: data.isActive,
  };

  return apiHelper(API_URL).put(
    `/${MODULE.ORIENTATION_MODULE_HEADER}/${data.uuid}`,
    request,
  );
}

export function updateStatus(data) {
  const request = {
    is_active: data.isActive,
  };

  return apiHelper(API_URL).patch(
    `/${MODULE.ORIENTATION_MODULE_HEADER}/${data.uuid}`,
    request,
  );
}
